import { AxiosResponse } from 'axios';
import axiosInstance from '../utils/axios';
import amplifyConfig from '../config';
import API_PATH from './endpoints';
import type { CreateOrganizationParams, DeleteOrganizationParams, OrganizationType, UpdateOrganizationParams, UpdateOrganizationParamsClient } from '../types/organization';

const organizationAPI = {
  /**
   * 組織一覧の取得
   * @return OrganizationType[]
   */
  getOrganizations: async () => {
    return axiosInstance.get<undefined, AxiosResponse<OrganizationType[]>>(amplifyConfig.apiGateway.URL + API_PATH.ORGANIZATION.ORGANIZATION);
  },

  /**
   * UseFlagがたった組織一覧の取得（with-use-flag ＝ 承認済みの可視制御を持つ）
   * @return OrganizationType[]
   */
  getOrganizationsWithUseFlag: async () => {
    return axiosInstance.get<undefined, AxiosResponse<OrganizationType[]>>(amplifyConfig.apiGateway.URL + API_PATH.ORGANIZATION.ORGANIZATION_WITH_USE_FLAG);
  },

  /**
   * 組織の作成
   * @param CreateOrganizationParams
   * @return OrganizationType
   */
  createOrganization: async (params: CreateOrganizationParams) => {
    return axiosInstance.post<CreateOrganizationParams, AxiosResponse<OrganizationType>>(amplifyConfig.apiGateway.URL + API_PATH.ORGANIZATION.ORGANIZATION, params);
  },

  /**
   * 組織の更新
   * @param UpdateOrganizationParamsClient
   * @return OrganizationType
   */
  updateOrganization: async (params: UpdateOrganizationParamsClient) => {
    const { id, organizationBaseId, organizationSuffixName, businessType, steelMaker, steelCategory } = params;
    return axiosInstance.put<UpdateOrganizationParams, AxiosResponse<OrganizationType>>(amplifyConfig.apiGateway.URL + API_PATH.ORGANIZATION.ORGANIZATION + '/' + String(id), {
      organizationBaseId,
      organizationSuffixName,
      businessType,
      steelMaker,
      steelCategory,
    });
  },

  /**
   * 組織の削除
   * @param DeleteOrganizationParams
   * @return OrganizationType
   */
  deleteOrganization: async (params: DeleteOrganizationParams) => {
    const { id } = params;
    return axiosInstance.delete<DeleteOrganizationParams, AxiosResponse<OrganizationType>>(amplifyConfig.apiGateway.URL + API_PATH.ORGANIZATION.ORGANIZATION + '/' + String(id));
  },
};

export default organizationAPI;
